import { CheckboxComponent } from '../common/form/checkbox';
import { IObservable, ISubject, Subject, BehaviorSubject } from '@app/utils/observable';
import { ICheckboxChangeArgs } from '@app/interfaces/checkbox';
import { toDictionary } from '@app/utils/to-dictionary';
import { IComponent } from '@app/interfaces/component';

export class AllowanceTypeAccordionItemComponent implements IComponent {
    private expenditureTypeChangeEventSubject: ISubject<AllowanceTypeAccordionItemComponent, AllowanceTypeAccordionItemExpenditureTypeChangeArgs>;
    
    private toggleAllElement: HTMLAnchorElement;
    private numberSelectedTextElement: HTMLElement;
    private nameElement: HTMLElement;
    
    public expenditureTypeIds: number[];
    public expenditureTypeMap: { [key: number]: CheckboxComponent<number>; };
    public get expenditureTypes(): CheckboxComponent<number>[] {
        return this.expenditureTypeIds.map(id => this.expenditureTypeMap[id]);
    }
    public get selectedExpenditureTypes(): CheckboxComponent<number>[] {
        return this.expenditureTypes.filter(e => e.checked);
    }

    private expenditureTypeBatchChangeEventArgs: AllowanceTypeAccordionItemExpenditureTypeChangeArgs | null = null;
	
    public get onExpenditureTypeChange$(): IObservable<AllowanceTypeAccordionItemComponent, AllowanceTypeAccordionItemExpenditureTypeChangeArgs> {
        return this.expenditureTypeChangeEventSubject;
    }

    public get name(): string {
        return this.nameElement.innerText;
    }

    constructor(public header: HTMLElement, public content: HTMLElement) {
        // Subject ctors
        this.expenditureTypeChangeEventSubject = new BehaviorSubject;
        
        // Function binding
        this.onExpenditureTypeChange = this.onExpenditureTypeChange.bind(this);
        this.onToggleAll = this.onToggleAll.bind(this);
        
        this.toggleAllElement = this.content.querySelector(".allowance-type-accordion__toggle-all") as HTMLAnchorElement;
        this.toggleAllElement.addEventListener("click", this.onToggleAll);

        this.numberSelectedTextElement = this.header.querySelector(".allowance-type-accordion__allowance-type-n-selected") as HTMLElement;

        this.nameElement = this.header.querySelector(".allowance-type-accordion__allowance-type-name") as HTMLElement;
        
        // Expenditure type checkboxes
        const allExpenditureTypeCheckboxes = $("input[type=checkbox]", this.content).get() as HTMLInputElement[];
        const expenditureTypeCheckboxes = allExpenditureTypeCheckboxes.map(input => new CheckboxComponent<number>(input));
        this.expenditureTypeIds = expenditureTypeCheckboxes.map(c => c.id);
        this.expenditureTypeMap = toDictionary(expenditureTypeCheckboxes, c => c.id);

        this.batchChangeOfExpenditureTypes(() => {
            for (const checkbox of expenditureTypeCheckboxes) {
                checkbox.onChange$.subscribe(this.onExpenditureTypeChange);
            }
        });
		
        this.onExpenditureTypeChange$.subscribe(() => {
            this.updateNumberSelectedText();
        });
        
    }

    get id(): number {
        return $(this.header).data('id') as number;
    }

    updateNumberSelectedText() {
		if (this.selectedExpenditureTypes.length === 0) {
            this.numberSelectedTextElement.textContent = "";
            return;
        }

        const nText = $(this.numberSelectedTextElement).data("selectedN");
        const allText = $(this.numberSelectedTextElement).data("selectedAll");

        const count = this.expenditureTypes.filter(e => e.checked).length;

        this.numberSelectedTextElement.textContent = count === this.expenditureTypes.length ? allText : nText.replace("{0}", count);
    }


    onToggleAll(ev: Event) {
	    ev.preventDefault();

	    const anySelected = this.expenditureTypes.some(e => e.checked);

	    this.setAllChecked(!anySelected);
    }

    setAllChecked(checked: boolean) {
        this.batchChangeOfExpenditureTypes(() => {
            for (const expenditureType of this.expenditureTypes) {
                expenditureType.checked = checked;
            }
        });
    }

    onExpenditureTypeChange(sender: CheckboxComponent<number>, args: ICheckboxChangeArgs<number>) {
        if (this.expenditureTypeBatchChangeEventArgs !== null) {
            this.expenditureTypeBatchChangeEventArgs.expenditureTypes.push(args);
            return;
        }

        this.expenditureTypeChangeEventSubject.emit(this, this.createAllowanceTypeAccordionItemExpenditureTypeChangeArgs([args]));
    }

    render() {
        return [
            this.header,
            this.content
        ];
    }

    public batchChangeOfExpenditureTypes(action: Function) {
        if (!this.expenditureTypeBatchChangeEventArgs) {
            this.expenditureTypeBatchChangeEventArgs = this.createAllowanceTypeAccordionItemExpenditureTypeChangeArgs();
        }

        action();

        if (this.expenditureTypeBatchChangeEventArgs) {
            this.expenditureTypeChangeEventSubject.emit(this, this.expenditureTypeBatchChangeEventArgs);
            this.expenditureTypeBatchChangeEventArgs = null;
        }
    }

    private createAllowanceTypeAccordionItemExpenditureTypeChangeArgs(expenditureTypes: ICheckboxChangeArgs<number>[] = []): AllowanceTypeAccordionItemExpenditureTypeChangeArgs {
        return {
            key: this.id,
            expenditureTypes: expenditureTypes
        };
    }
}

export interface AllowanceTypeAccordionItemExpenditureTypeChangeArgs {
    key: number;
    expenditureTypes: ICheckboxChangeArgs<number>[];
}